// src/data/activities.js

export const activityCategories = [
  {
    id: "physical-touch-intimacy",
    name: "Physical Touch & Intimacy",
    activities: [
      { id: "masturbation", label: "Masturbation" },
      { id: "holding-hands", label: "Holding hands" },
      { id: "kissing", label: "Kissing" },
      { id: "necking", label: "Necking (kissing on the neck)" },
      {
        id: "activities-marks",
        label: "Activities that leave marks (hickeys, etc.)",
      },
      { id: "tickling", label: "Tickling" },
      { id: "wrestling", label: "Wrestling or play-fighting" },
      { id: "massage", label: "Massage (back, shoulders, legs)" },
      { id: "chest-breast-play", label: "Chest/Breast/Nipple play" },
      { id: "dry-humping", label: "Dry humping/clothed body-to-body rubbing" },
      {
        id: "tribadism",
        label: "Tribadism (scissoring, rubbing naked genitals together)",
      },
      { id: "chest-licking", label: "Chest/Breast/Nipple licking/sucking" },
      { id: "chest-biting", label: "Chest/Breast/Nipple biting" },
      {
        id: "masturbating-with-partner",
        label: "Masturbating in front of a partner",
      },
    ],
  },
  {
    id: "manual-stimulation",
    name: "Manual Stimulation",
    activities: [
      { id: "hands-penis", label: "Hands or fingers on penis" },
      { id: "hands-strap-on", label: "Hands or fingers on strap-on" },
      { id: "hands-testes", label: "Hands or fingers on testes" },
      { id: "hands-vulva", label: "Hands or fingers on vulva" },
      { id: "fingers-vagina", label: "Fingers inside vagina" },
      { id: "vaginal-fisting", label: "Vaginal fisting" },
      { id: "hands-anus", label: "Hands or fingers on or around anus" },
      { id: "fingers-rectum", label: "Fingers inside rectum" },
      { id: "anal-fisting", label: "Anal fisting" },
    ],
  },
  {
    id: "oral-activities",
    name: "Oral Activities",
    activities: [
      { id: "tongue-vulva", label: "Tongue or mouth on vulva" },
      { id: "tongue-penis", label: "Tongue or mouth on penis" },
      { id: "tongue-strap-on", label: "Tongue or mouth on strap-on" },
      { id: "tongue-testes", label: "Tongue or mouth on testes" },
      { id: "tongue-anus", label: "Tongue or mouth on anus (rimming)" },
    ],
  },
  {
    id: "penetration",
    name: "Penetration",
    activities: [
      { id: "vaginal-intercourse", label: "Vaginal intercourse" },
      { id: "anal-intercourse", label: "Anal intercourse" },
      { id: "ejaculating-on-body", label: "Ejaculating on someone's body" },
      { id: "ejaculating-in-body", label: "Ejaculating in someone's body" },
    ],
  },
  {
    id: "toys-props",
    name: "Toys & Props",
    activities: [
      { id: "vibrators-alone", label: "Using vibrators alone" },
      { id: "dildos-alone", label: "Using dildos alone" },
      { id: "sleeves-alone", label: "Using masturbation sleeves alone" },
      { id: "vibrators-partner", label: "Using vibrators with a partner" },
      { id: "dildos-partner", label: "Using dildos with a partner" },
      {
        id: "sleeves-partner",
        label: "Using masturbation sleeves with a partner",
      },
      {
        id: "food-items",
        label: "Using food items as part of sex (never inserted)",
      },
    ],
  },
  {
    id: "kink-bdsm",
    name: "Kink & BDSM",
    activities: [
      { id: "cross-dressing", label: "Cross-dressing during sex" },
      { id: "biting", label: "Biting" },
      { id: "scratching", label: "Scratching" },
      { id: "blindfolding", label: "Blindfolding" },
      {
        id: "restricting-movement",
        label: "Restricting movement (rope bondage, restraints, etc.)",
      },
      { id: "slapping-spanking", label: "Slapping or spanking" },
      { id: "pinching", label: "Pinching" },
      { id: "clamps", label: "Clamps (nipple clamps, etc.)" },
      { id: "impact-play", label: "Paddles, floggers, whips, crops, canes" },
      { id: "role-playing", label: "Role playing" },
      { id: "dirty-talk", label: "Dirty talk" },
    ],
  },
  {
    id: "digital-distance",
    name: "Digital & Distance",
    activities: [
      { id: "phone-sex", label: "Phone sex" },
      { id: "video-sex", label: "Video sex (Skype, FaceTime, etc.)" },
      { id: "sexting", label: "Sexting" },
      { id: "reading-erotica-alone", label: "Reading erotica alone" },
      {
        id: "reading-erotica-partner",
        label: "Reading erotica with/to a partner",
      },
      { id: "watching-porn-alone", label: "Watching porn alone" },
      { id: "watching-porn-partner", label: "Watching porn with a partner" },
    ],
  },
  {
    id: "safer-sex",
    name: "Safer Sex & Protection",
    activities: [
      { id: "protection-oral", label: "Using protection during oral sex" },
      {
        id: "protection-intercourse",
        label: "Using protection during intercourse",
      },
      { id: "latex-gloves", label: "Using latex gloves" },
      { id: "sti-testing", label: "STI/HIV Testing" },
    ],
  },
  {
    id: "relationship-structure",
    name: "Relationship Structure",
    activities: [
      { id: "monogamy", label: "Monogamy" },
      { id: "polyamory", label: "Polyamory" },
      { id: "threesome", label: "Threesome" },
      { id: "orgy", label: "Orgy" },
      { id: "fuck-buddy", label: "Fuck buddy / casual relationship" },
      {
        id: "kiss-tell",
        label: "Kiss and tell (talking to friends about what happens)",
      },
    ],
  },
];

// Helper function to get all activity IDs in a flat array
export const getAllActivityIds = () => {
  return activityCategories.flatMap((category) =>
    category.activities.map((activity) => activity.id),
  );
};

// Helper function to find mutual matches
export const findMutualMatches = (responses) => {
  if (responses.length === 0) return [];

  // Start with the first person's activities
  let matches = new Set(responses[0].activities);

  // Intersect with each subsequent person's activities
  responses.slice(1).forEach((response) => {
    const responseSet = new Set(response.activities);
    matches = new Set([...matches].filter((id) => responseSet.has(id)));
  });

  return Array.from(matches);
};

// Helper function to find partial matches (2+ people agreed, but not everyone)
export const findPartialMatches = (responses) => {
  if (responses.length < 2) return [];

  const mutualMatches = new Set(findMutualMatches(responses));
  const activityCounts = {};

  // Count how many people selected each activity
  responses.forEach((response) => {
    response.activities.forEach((activityId) => {
      activityCounts[activityId] = (activityCounts[activityId] || 0) + 1;
    });
  });

  // Find activities where 2+ people agreed but not everyone
  const partialMatches = [];
  Object.entries(activityCounts).forEach(([activityId, count]) => {
    // Include if 2+ people but not everyone, and not already a mutual match
    if (
      count >= 2 &&
      count < responses.length &&
      !mutualMatches.has(activityId)
    ) {
      partialMatches.push({
        activityId,
        count,
        total: responses.length,
      });
    }
  });

  // Sort by count descending (most people first)
  return partialMatches.sort((a, b) => b.count - a.count);
};

// Helper function to organize matches by category
export const organizeMatchesByCategory = (matchIds) => {
  return activityCategories
    .map((category) => ({
      ...category,
      activities: category.activities.filter((activity) =>
        matchIds.includes(activity.id),
      ),
    }))
    .filter((category) => category.activities.length > 0);
};

// Helper function to organize partial matches by category
export const organizePartialMatchesByCategory = (partialMatches) => {
  // Create a map of activityId to count info
  const matchMap = {};
  partialMatches.forEach((match) => {
    matchMap[match.activityId] = match;
  });

  return activityCategories
    .map((category) => ({
      ...category,
      activities: category.activities
        .filter((activity) => matchMap[activity.id])
        .map((activity) => ({
          ...activity,
          count: matchMap[activity.id].count,
          total: matchMap[activity.id].total,
        })),
    }))
    .filter((category) => category.activities.length > 0);
};
